import { TypeMappingRow } from "@common/helpers/chartOfAccountsTemplateTypeMapping";
import { View, ViewDensity } from "@common/types/views/views";
import { ViewConfig } from "@lib/views";
import { TypeMappingNameCell } from "./cells/TypeMappingNameCell";
import { TypeMappingTypeCell } from "./cells/TypeMappingTypeCell";

export enum TypeMappingColumn {
    NAME = "name",
    TYPE = "type",
}

export const typeMappingViewConfig: ViewConfig<
    TypeMappingRow,
    TypeMappingColumn,
    never
> = {
    columns: {
        [TypeMappingColumn.NAME]: {
            accessorKey: "name",
            name: "Imported account",
            header: "Imported account",
            cell: TypeMappingNameCell,
            immutable: true,
            minSize: 320,
        },
        [TypeMappingColumn.TYPE]: {
            accessorKey: "id",
            name: "Kick type",
            header: "Kick type",
            cell: TypeMappingTypeCell,
            minSize: 220,
            maxSize: 220,
        },
    },
    nesting: {
        enabled: true,
        expandColumn: TypeMappingColumn.NAME,
        childrenKey: "children",
    },
};

export const typeMappingView: View = {
    columns: [{ id: TypeMappingColumn.NAME }, { id: TypeMappingColumn.TYPE }],
    filters: {},
    options: {
        density: ViewDensity.MD,
    },
};
